
export const RECOMMENTEDPRICE_ONCHANGE = 'RECOMMENTEDPRICE_ONCHANGE';
export const updateRecommendedPrice = (value) => ({
    type: RECOMMENTEDPRICE_ONCHANGE,
    payload: {
        isrecommendedprice: value
    },
}
);



